import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import ConfigAction from 'redux/actions/configAction';

export interface SystemConfiguration { 
  dateTimeFormat?: string;
  getSystemDateTimeFormat: () => Promise<void>;
}

export const useSystemConfiguration = (): SystemConfiguration => {
  const { systemConfig, generalConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );
  const { dateTimeFormat } = generalConfig;

  const dispatch = useDispatch();

  const getSystemDateTimeFormat = async () => {
    if (Object.keys(systemConfig).length === 0) {
      try {
        dispatch(ConfigAction.setSystemConfigSuccess({dateTimeFormat}));
      } catch (error) {
        console.log(error);
      }
    }
  }

  return {
    ...systemConfig,
    getSystemDateTimeFormat
  };
};
